import React from 'react';
import { List, Text, Button, Link } from '@shootsta/common-react';
import { INFORMATION_STEPS_LIST } from '../constants/informationStepsList';
import '../styles/_information-steps.scss';

type InformationStepsListProps = {
  onSelectInformationStep: any;
};

export default function InformationStepsList({
  onSelectInformationStep
}: InformationStepsListProps) {
  return INFORMATION_STEPS_LIST.map<any>((step) => (
    <List.CardItem className="information-steps__item">
      <Text
        className="information-steps__title"
        prefixIcon={step.prefix}
        prefixSize={step.prefixSize}
        heading5
      >
        {step.label}
      </Text>

      {step.link ? (
        <Button className="information-steps__button" type="TERTIARY">
          <Link onClick={() => onSelectInformationStep(step)}>
            {step.value}
          </Link>
        </Button>
      ) : (
        step.value
      )}
    </List.CardItem>
  ));
}
